import { createApp } from 'vue'
import StafetDeltagPaaHoldStepYourInformation from './StafetDeltagPaaHoldStepYourInformation'

const el = '.kb-component--stafet-join-a-team-step-your-information'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetDeltagPaaHoldStepYourInformationDOM) => {
            const component = createApp(StafetDeltagPaaHoldStepYourInformation).use(Store)
            component.mount(StafetDeltagPaaHoldStepYourInformationDOM)
        })
    }
}
